var CursorMode = /* @__PURE__ */ function(CursorMode2) {
  CursorMode2[CursorMode2["Normal"] = 0] = "Normal";
  CursorMode2[CursorMode2["Hidden"] = 1] = "Hidden";
  CursorMode2[CursorMode2["Chat"] = 2] = "Chat";
  CursorMode2[CursorMode2["Ephemeral"] = 3] = "Ephemeral";
  return CursorMode2;
}({});

export { CursorMode };
//# sourceMappingURL=presence.js.map
